// extracted by mini-css-extract-plugin
export default {"container":"styles_container__7Nl-q","textWrapper":"styles_textWrapper__SmAp-","link":"styles_link__rCsmH"};